<template>
  <div>
    <b-form @submit.stop.prevent="onSubmit">
      <b-form-group :label="$t('message.Название') + ':'" label-for="Name">
        <b-form-input id="Name" type="text" v-model="model.name"></b-form-input>
      </b-form-group>
      <b-form-group :label="$t('message.Комментарий') + ':'" label-for="Comment">
        <b-form-input id="Comment" type="text" v-model="model.comment"></b-form-input>
      </b-form-group>
    </b-form>
  </div>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "PackageForm",
  props: ["model"],
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/modules/PackageForm.vue